import { route } from "client/Navigation";
import { AnnouncementsPageQueryParams, AnnouncementsPageRouteParams } from "./Announcements/AnnouncementsPage";
import { KnowledgeItemsPageQueryParams, KnowledgeItemsPageRouteParams } from "./KnowledgeItems/KnowledgeItemsPage";
import { EventsPageQueryParams, EventsPageRouteParams } from "./Events/EventsPage";
import { CommunitiesPageRouteParams } from "./Communities/CommunitiesPage";
import { CommunityPostPageQueryParams, CommunityPostPageRouteParams } from "./Communities/CommunityPostPage";

export const hubRouting = {
	page: route`/Hub`,
	announcements: route<AnnouncementsPageRouteParams, AnnouncementsPageQueryParams>`/Hub/Announcements/${"id?"}`,
	knowledgeItems: route<KnowledgeItemsPageRouteParams, KnowledgeItemsPageQueryParams>`/Hub/KnowledgeItems/${"id?"}`,
	events: route<EventsPageRouteParams, EventsPageQueryParams>`/Hub/Events/${"id?"}`,
	communities: {
		overviews: route<CommunitiesPageRouteParams>`/Hub/Communities/${"id?"}`,
		post: route<CommunityPostPageRouteParams, CommunityPostPageQueryParams>`/Hub/Posts/${"id"}`
	}
};
